import { getLocalStorageData, LocalStorageKeys } from 'utils/localstorage';
import AppSplash from './AppSplash';

//
// The loader of the whole app, while the first scene's code and translations load: the splash, as the static shell of
// index.html shows it, in the user's last color mode (the app context does not exist yet).
//
const AppLoader = () => {
  return <AppSplash visible dark={getLocalStorageData(undefined, LocalStorageKeys.DarkMode) === 'true'} />;
};

export default AppLoader;
